class Form {
  constructor() {
    this.element = null;
  }

  init(element) {
    this.element = this.getFormElement(element);

    if (!this.element) {
      return;
    }

    this.element.setAttribute('novalidate', '');

    this.initEventListeners();
  }

  getFormElement(element) {
    return element || document.querySelector('js-form');
  }

  initEventListeners() {
    this.element.addEventListener('submit', this.onFormSubmit.bind(this));
  }

  onFormSubmit(event) {
    event.preventDefault();
    const formElement = this.element;

    var checkboxes = document.querySelectorAll('input[type="checkbox"][data-check-valid="true"]');
    var errorMessage = document.querySelector('.js-checkbox-error');
    var checkboxGroupTitle = document.querySelector('.js-checkbox-group-title');
    var checked = false;

    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        checked = true;
        break;
      }
    }

    if (formElement.checkValidity() && checked) {
      if (this.functionalSubmit) {
        this.onSubmit.emit(event);
      } else {
        formElement.submit();
      }
      checkboxGroupTitle.classList.remove("error");
    } else if (!!this.validate) {
      formElement.reportValidity();
    } else if (!checked) {
      event.preventDefault(); // Prevent form submission
      errorMessage.removeAttribute("hidden");
      checkboxGroupTitle.classList.add("error");
    }

    setTimeout(() => {
      // check for element with error and scroll into view
      const invalidElement = formElement.querySelector('.error');

      if (!!invalidElement) {
        const invalidControl = invalidElement.querySelector('[data-control]');

        // Scroll window to element position
        window.scrollTo(0, invalidElement.offsetTop - 140);

        if (!!invalidControl) {
          invalidControl.focus();
        }
      }
    }, 50);
  }
}

export default Form;
